export default {
    'A name is required': 'A name is required',
    Age: 'Age',
    'Total money spent, $': 'Total money spent, $',
    Clients: 'Clients',
    Income: 'Income',
    'First name': 'First name',
    'Last name': 'Last name',
    Position: 'Position',
    'Click para seleccionar ': 'Click para seleccionar ',
    Notifications: 'Notifications',
    Yes: 'Yes',
    No: 'No',
    'City, country': 'City, country',
    Address: 'Address',
    Birthday: 'Birthday',
    'Click to add tags': 'Click to add tags',
    Notes: 'Notes',
    Reset: 'Reset',
    Save: 'Save',
    'Top clients': 'Top clients',
    'Money spent, $': 'Money spent, $',
    '-- Not selected --': '-- Not selected --',
    'Sales manager': 'Sales manager',
    'Customer service': 'Customer service',
    'General manager': 'General manager',
    New: 'New',
    Customer: 'Customer',
    Supplier: 'Supplier',
    Discount: 'Discount',
    'Old Buddy': 'Old Buddy',
    'Avid Supporter': 'Avid Supporter',
    Date: 'Date',
    Payment: 'Payment',
    Purchase: 'Purchase',
    Sum: 'Sum',
    Left: 'Left',
    'Nothing on this day': 'Nothing on this day',
    Information: 'Information',
    Statistics: 'Statistics',
    Transactions: 'Transactions',
    Customers: 'Customers',
    Charts: 'Charts',
    'See all notifications': 'See all notifications',
    'Deposits News': 'Deposits News',
    'Dear client, we inform you about the following changes: beginning from September 24, 2018 all transactions (incoming and out...':
        'Dear client, we inform you about the following changes: beginning from September 24, 2018 all transactions (incoming and out...',
    'Search Improved': 'Search Improved',
    'Dear client! Following the latest updates of the SeekMeEverywhere engines, your search has become more reliable and convenient! No...':
        'Dear client! Following the latest updates of the SeekMeEverywhere engines, your search has become more reliable and convenient! No...',
    'Transaction Reports': 'Transaction Reports',
    'Dear client, we inform you about a change in the date of monthly transaction reports. Beginning from September 20, 2018 reports...':
        'Dear client, we inform you about a change in the date of monthly transaction reports. Beginning from September 20, 2018 reports...',
    Warning: 'Warning',
    'Dear client, we know where you store your passwords. We highly recommend you to memorize them and destroy those memos of yours.':
        'Dear client, we know where you store your passwords. We highly recommend you to memorize them and destroy those memos of yours.',
    'Editing customers data': 'Editing customers data',
    'Dear client, if you want to see the details on every customer and edit them, double-click the customer in the list on the right.':
        'Dear client, if you want to see the details on every customer and edit them, double-click the customer in the list on the right.',
    'We miss you': 'We miss you',
    'Dear client, it has been a while since you talked to us. We are waiting for you in the same place at the same time.':
        'Dear client, it has been a while since you talked to us. We are waiting for you in the same place at the same time.',
    'Have a nice day': 'Have a nice day',
    'Dear client, whenever you are reading this, we wish you a merry day. May the luck and success attend you.':
        'Dear client, whenever you are reading this, we wish you a merry day. May the luck and success attend you.',
    Localization: 'Localization',
    'Dear client, you can pick one of the six languages we provided for this demo app. Click the icon in the top right corner.':
        'Dear client, you can pick one of the six languages we provided for this demo app. Click the icon in the top right corner.',
    'We love you': 'We love you',
    'Dear client, we love you very much. If our feelings are mutual, contact us and download Webix. Then we will love you eternally.':
        'Dear client, we love you very much. If our feelings are mutual, contact us and download Webix. Then we will love you eternally.',
    Persons: 'Persons',
    'Click twice to see more goodies': 'Click twice to see more goodies',
    Saved: 'Saved',
    Settings: 'Settings',
    'Regional settings': 'Regional settings',
    Language: 'Language',
    'Date format': 'Date format',
    'Money format': 'Money format',
    'Environment settings': 'Environment settings',
    Theme: 'Theme',
    Light: 'Light',
    Dark: 'Dark',
    'Max list length': 'Max list length',
    'Default settings': 'Default settings',
    'Open latest notifications': 'Open latest notifications',
    'Go to settings': 'Go to settings',
    All: 'All',
    Payments: 'Payments',
    Incoming: 'Incoming',
    Email: 'Email',
    Widgets: 'Widgets',
    Demos: 'Demos',
    Prices: 'Prices',
    Tutorials: 'Tutorials',
    'Tirane, Albania': 'Tirane, Albania',
    'Buenos Aires, Argentina': 'Buenos Aires, Argentina',
    'Canberra, Australia': 'Canberra, Australia',
    'Vienna, Austria': 'Vienna, Austria',
    'Minsk, Belarus': 'Minsk, Belarus',
    'Brussels, Belgium': 'Brussels, Belgium',
    'Brasilia, Brazil': 'Brasilia, Brazil',
    'Ottawa, Canada': 'Ottawa, Canada',
    'Beijing, China': 'Beijing, China',
    'Prague, Czech Republic': 'Prague, Czech Republic',
    'Copenhagen, Denmark': 'Copenhagen, Denmark',
    'Cairo, Egypt': 'Cairo, Egypt',
    'Helsinki, Finland': 'Helsinki, Finland',
    'Paris, France': 'Paris, France',
    'Tbilisi, Georgia': 'Tbilisi, Georgia',
    'Berlin, Germany': 'Berlin, Germany',
    'New Delhi, India': 'New Delhi, India',
    'Dublin, Ireland': 'Dublin, Ireland',
    'Rome, Italy': 'Rome, Italy',
    'Tokyo, Japan': 'Tokyo, Japan',
    'Wellington, New Zealand': 'Wellington, New Zealand',
    'Seoul, Republic of Korea': 'Seoul, Republic of Korea',
    'Madrid, Spain': 'Madrid, Spain',
    'Stockholm, Sweden': 'Stockholm, Sweden',
    'Washington, United States': 'Washington, United States',
    'Payment History': 'Payment History',
    'Origin of clients': 'Origin of clients',
    'Income from various age groups': 'Income from various age groups',
    'Awarded Badges': 'Awarded Badges',
    'Clients by occupation': 'Clients by occupation',
    'No new notifications': 'No new notifications',

    'Añadir Egreso': 'Add expense',
    'Añadir Ingreso': 'Add Income',
    'Saldo Recargas:': 'Balance Recharges:',
    'Saldo Juego:': 'Balance Game:',
    Nombre: 'Name',
    Hoy: 'Today',
    Ayer: 'Yesterday',
    'Ultimos 30 días': 'Last 30 days',
    Depósitos: 'Deposits',
    Retiros: 'Withdrawal',
    Neto: 'Net',
    'Advertencia!': 'Warning!',
    'Desea cambiar la contraseña?': 'Do you want to change the password?',
    Salir: 'Go out',
    Descripción: 'Description',
    Activado: 'Activated',
    Inactivado: 'Inactivated',

    'Número de usuario': 'Número de usuario',
    'Login para acceso': 'Login para acceso',
    'Última dirección IP': 'Última dirección IP',
    'Último usuario modif': 'Último usuario modif',
    Tipo: 'Tipo',
    Agente: 'Agente',
    Afiliado: 'Afiliado',
    'Click para seleccionar': 'Click para seleccionar',
    'Click para seleccionar ': 'Click para seleccionar ',
    Estado: 'Estado',
    Activo: 'Activo',
    Inactivo: 'Inactivo',
    Retirado: 'Retirado',
    'Idioma preferido:': 'Idioma preferido:',
    'Nombre del usuario': 'Nombre del usuario',
    País: 'País',
    'Campo Requerido': 'Campo Requerido',
    Moneda: 'Moneda',
    'Fecha de creación': 'Fecha de creación',
    'Fecha última entrada': 'Fecha última entrada',
    'Última Fecha modif': 'Última Fecha modif',
    'Estado especial': 'Estado especial',
    Pinagent: 'Pinagent',
    Sí: 'Sí',
    No: 'No',
    'Bloqueado para ventas': 'Bloqueado para ventas',
    'Imprime recibo caja': 'Imprime recibo caja',
    'Permite recargas': 'Permite recargas',
    'Permite activar reg': 'Permite activar reg',
    'Nombre del contacto': 'Nombre del contacto',
    'Correo electrónico': 'Correo electrónico',
    Teléfono: 'Teléfono',
    Concesionario: 'Concesionario',
    Subconcesionario: 'Subconcesionario',
    'Provincia/Región': 'Provincia/Región',
    Ciudad: 'Ciudad',
    Dirección: 'Dirección',
    Barrio: 'Barrio',
    'Cupo diario recargas': 'Cupo diario recargas',
    'Comisión recargas': 'Comisión recargas',
    'Apuesta mínima': 'Apuesta mínima',
    'Límite diario': 'Límite diario',
    'Datos Principales': 'Datos Principales',
    'Datos Agente': 'Datos Agente',
    'Datos Configuracion': 'Datos Configuracion',
    Limpiar: 'Limpiar',
    Guardar: 'Guardar',
    'Completa los campos...': 'Completa los campos...',
    'Mi Información': 'Mi Información',
    'Contraseña Actual': 'Contraseña Actual',
    'Nueva Contraseña': 'Nueva Contraseña',
    'La contraseña debe contener mínimo 8 caracteres, una minúscula, una mayúscula y un número.':
        'La contraseña debe contener mínimo 8 caracteres, una minúscula, una mayúscula y un número.',
    'Confirmar Contraseña': 'Confirmar Contraseña',
    'Contraseñas no coinciden': 'Contraseñas no coinciden',
    'Advertencia!': 'Advertencia!',
    'Contraseña cambiada satisfactoriamente': 'Contraseña cambiada satisfactoriamente',
    '¡Exito!': '¡Exito!',
    'Nueva contraseñas no coinciden': 'Nueva contraseñas no coinciden',
    'Verifique los campos...': 'Verifique los campos...',
    'Cambiar mi contraseña': 'Cambiar mi contraseña',
    Slug: 'Slug',
    Superior: 'Superior',
    'Editar Categoría': 'Editar Categoría',
    Cancelar: 'Cancelar',
    'Categoría Editada': 'Categoría Editada',
    'Añadir Categoría': 'Añadir Categoría',
    'Categoría Agregada': 'Categoría Agregada',
    Todos: 'Todos',
    'Filtros Avanzados': 'Filtros Avanzados',
    Consultar: 'Consultar',
    Categoría: 'Categoría',
    Productos: 'Productos',
    'Agragar Categoría Producto': 'Agragar Categoría Producto',
    'Categoría Producto Editada': 'Categoría Producto Editada',
    'Editar Categorias Productos': 'Editar Categorias Productos',
    'Categoría Producto Agregada': 'Categoría Producto Agregada',
    Categorías: 'Categorías',
    'Añadir Categoría Producto': 'Añadir Categoría Producto',
    'Nombre Encargado': 'Nombre Encargado',
    Nit: 'Nit',
    'Es propio?': 'Es propio?',
    'Añadir Tipo Producto Partner': 'Añadir Tipo Producto Partner',
    'Partner Agregado': 'Partner Agregado',
    'Añadir Partner': 'Añadir Partner',
    Producto: 'Producto',
    Proveedor: 'Proveedor',
    Partner: 'Partner',
    Verificado: 'Verificado',
    'Filtro País': 'Filtro País',
    Mobile: 'Mobile',
    Escritorio: 'Escritorio',
    Máximo: 'Máximo',
    Mínimo: 'Mínimo',
    'Tiempo Procesamiento': 'Tiempo Procesamiento',
    Orden: 'Orden',
    'Orden Destacado': 'Orden Destacado',
    Filas: 'Filas',
    Columnas: 'Columnas',
    'Editar Productos Partner': 'Editar Productos Partner',
    'Producto Partner Editado': 'Producto Partner Editado',
    'Añadir Producto Partner': 'Añadir Producto Partner',
    'Producto Partner Agregado': 'Producto Partner Agregado',
    Dispositivo: 'Dispositivo',
    Editar: 'Editar',
    Detalle: 'Detalle',
    'Editar Partner': 'Editar Partner',
    Proveedores: 'Proveedores',
    'Proveedor Partner Agregado': 'Proveedor Partner Agregado',
    'Proveedor Partner Editado': 'Proveedor Partner Editado',
    Imagen: 'Imagen',
    'Imagen URL': 'Imagen URL',
    'ID Externo': 'ID Externo',
    Visible: 'Visible',
    'Producto Id': 'Producto Id',
    'Editar Producto': 'Editar Producto',
    'Añadir Producto': 'Añadir Producto',
    Abreviado: 'Abreviado',
    'Proveedor Id': 'Proveedor Id',
    Ambos: 'Ambos',
    'ID Usuario': 'ID Usuario',
    'Usuario (Correo electrónico)': 'Usuario (Correo electrónico)',
    Apellido: 'Apellido',
    Documento: 'Documento',
    'Estado de Registro': 'Estado de Registro',
    Rechazado: 'Rechazado',
    Bloqueado: 'Bloqueado',
    'Fecha de ultimo login': 'Fecha de ultimo login',
    'Codigo Promocional': 'Codigo Promocional',
    'Desea activar registro?': 'Desea activar registro?',
    'Activar registro': 'Activar registro',
    'Ocurrio un error, comuniquese con soporte': 'Ocurrio un error, comuniquese con soporte',
    'No puedes activar un registro ya actualizado.': 'No puedes activar un registro ya actualizado.',
    'Desea rechazar registro?': 'Desea rechazar registro?',
    'Rechazar registro': 'Rechazar registro',
    Error: 'Error',
    '¡Error!': '¡Error!',
    'Medio de Registro': 'Medio de Registro',
    'Sub Categoría': 'Sub Categoría',
    'Fecha final de la autoexclusión': 'Fecha final de la autoexclusión',
    'Usuario Creación': 'Usuario Creación',
    'Usuario Modificó': 'Usuario Modificó',
    Juego: 'Juego',
    'Tipo saldo': 'Tipo saldo',
    'Saldo recargas': 'Saldo recargas',
    'Saldo retiros': 'Saldo retiros',
    Detalles: 'Detalles',
    Historial: 'Historial',
    None: 'None',
    Cancelado: 'Cancelado',
    'Añadir Ajuste': 'Añadir Ajuste',
    'Nombre Usuario': 'Nombre Usuario',
    Movimiento: 'Movimiento',
    Entrada: 'Entrada',
    Salida: 'Salida',
    Cancelación: 'Cancelación',
    Valor: 'Valor',
    Respuesta: 'Respuesta',
    Abierto: 'Abierto',
    Cerrado: 'Cerrado',
    'Detalles del Ticket': 'Detalles del Ticket',
    'Ticket Det Id': 'Ticket Det Id',
    'Ticket ID': 'Ticket ID',
    Market: 'Market',
    Fecha: 'Fecha',
    'Transacción ID': 'Transacción ID',
    Monto: 'Monto',
    'Historial de Transacciones': 'Historial de Transacciones',
    Usuario: 'Usuario',
    Premios: 'Premios',
    Pendiente: 'Pendiente',
    Redimido: 'Redimido',
    Expirado: 'Expirado',
    Libre: 'Libre',
    Deposito: 'Deposito',
    'No Deposito': 'No Deposito',
    'Partner Bono Id': 'Partner Bono Id',
    'Bono ID': 'Bono ID',
    'ID Cliente': 'ID Cliente',
    'Id Bono': 'Id Bono',
    'Nombre de Bono': 'Nombre de Bono',
    'Fecha Aceptación': 'Fecha Aceptación',
    'Fecha Modificación': 'Fecha Modificación',
    'Monto Convertido': 'Monto Convertido',
    'Rollover Requerido': 'Rollover Requerido',
    Apostado: 'Apostado',
    Restante: 'Restante',
    'Fecha Expiración': 'Fecha Expiración',
    Apuestas: 'Apuestas',
    Ganancias: 'Ganancias',
    'Premios Bonos': 'Premios Bonos',
    'Beneficio %': 'Beneficio %',
    'Nombre Sistema Pasarela Pago': 'Nombre Sistema Pasarela Pago',
    Pagada: 'Pagada',
    Rechazada: 'Rechazada',
    Detallado: 'Detallado',
    Totales: 'Totales',
    'Resumen Financiero': 'Resumen Financiero',
    'Ajustar Saldo': 'Ajustar Saldo',
    'Usuario Id:': 'Usuario Id:',
    'Tipo Saldo:': 'Tipo Saldo:',
    'Monto:': 'Monto:',
    'Transacción Id': 'Transacción Id',
    Ganó: 'Ganó',
    Perdió: 'Perdió',
    'No Acción': 'No Acción',
    'En Espera': 'En Espera',
    'Rechazada por Regla': 'Rechazada por Regla',
    'Retiro Voluntario': 'Retiro Voluntario',
    'Dirección IP': 'Dirección IP',
    Market: 'Market',
    Odds: 'Odds',
    'Cambiar Contraseña': 'Cambiar Contraseña',
    Código: 'Código',
    'Generar Token': 'Generar Token',
    'Desbloquear Usuario por Clave': 'Desbloquear Usuario por Clave',
    Desbloquear: 'Desbloquear',
    'Ocurrio un error.': 'An error occurred.',
    'Cambios Realizados': 'Cambios Realizados',
    'Estado de Usuario': 'Estado de Usuario',
    'Estado de Contingencia': 'Estado de Contingencia',
    'Contingencia Deportivas': 'Contingencia Deportivas',
    'Contingencia Casino': 'Contingencia Casino',
    'Contingencia Casino en Vivo': 'Contingencia Casino en Vivo',
    'Estado de Contingencia Virtuales': 'Estado de Contingencia Virtuales',
    'Estado de Contingencia Poker': 'Estado de Contingencia Poker',
    'Estado de Registro del Usuario': 'Estado de Registro del Usuario',
    'Verificó DNI anterior': 'Verificó DNI anterior',
    Sí: 'Sí',
    No: 'No',
    'Verificó DNI posterior': 'Verificó DNI posterior',
    'Nombre sistema de pago': 'Nombre sistema de pago',
    'ID Cuenta': 'ID Cuenta',
    Banco: 'Banco',
    'Número Cuenta Bancaria': 'Número Cuenta Bancaria',
    'Código Interbancario': 'Código Interbancario',
    'Tipo Cuenta': 'Tipo Cuenta',
    Ahorros: 'Ahorros',
    Corriente: 'Corriente',
    'Cuenta Bancaria editada satisfactoriamente': 'Cuenta Bancaria editada satisfactoriamente',
    'Formas de Pago': 'Formas de Pago',
    Efectivo: 'Efectivo',
    'Cuenta Bancaria': 'Cuenta Bancaria',
    'Giro Bancario': 'Giro Bancario',
    'Punto de Venta': 'Punto de Venta',
    Filtros: 'Filtros',
    'Seguridad Cambios': 'Seguridad Cambios',
    Exportar: 'Exportar',
    'Cuentas Bancarias': 'Cuentas Bancarias',
    'Total Depósitos': 'Total Depósitos',
    'Total Apuestas Deportivas': 'Total Apuestas Deportivas',
    'Total Ganancias Deportivas': 'Total Ganancias Deportivas',
    'Total Apuestas Casino': 'Total Apuestas Casino',
    'Ganancias Totales Casino': 'Ganancias Totales Casino',
    'Total Retiros': 'Total Retiros',
    'Total Ajustes Entrada': 'Total Ajustes Entrada',
    'Total Ajustes Salida': 'Total Ajustes Salida',
    'Detalles Avanzados': 'Detalles Avanzados',
    Guardado: 'Guardado',
    'Error! ': 'Error! ',
    'Añadir Cuenta': 'Añadir Cuenta',
    Cuenta: 'Cuenta',
    'Editar Cuenta': 'Editar Cuenta',
    'Cuenta Actualizado': 'Cuenta Actualizado',
    'Cuenta Agregado': 'Cuenta Agregado',
    Encargado: 'Encargado',
    'Añadir Área': 'Añadir Área',
    'Editar Área': 'Editar Área',
    'Área Actualizado': 'Área Actualizado',
    'Área Agregado': 'Área Agregado',
    'Datos no han podido ser cargados': 'Datos no han podido ser cargados',
    'Hora Inicio': 'Hora Inicio',
    'Hora Cierre': 'Hora Cierre',
    'ID Plan de Cuentas': 'ID Plan de Cuentas',
    Referencia: 'Referencia',
    'Añadir Concepto': 'Añadir Concepto',
    'Plan de cuenta': 'Plan de cuenta',
    'Cuenta Id': 'Cuenta Id',
    'Editar Concepto': 'Editar Concepto',
    'Concepto Actualizado': 'Concepto Actualizado',
    'Concepto Agregado': 'Concepto Agregado',
    'Tipo de Centro': 'Tipo de Centro',
    'Añadir Centro': 'Añadir Centro',
    'Editar Centro': 'Editar Centro',
    'Centro Actualizado': 'Centro Actualizado',
    'Centro Agregado': 'Centro Agregado',
    Área: 'Área',
    Cargo: 'Cargo',
    'Añadir Empleado': 'Añadir Empleado',
    'Tipo Documento': 'Tipo Documento',
    Cedula: 'Cedula',
    'Cedula de extrangería': 'Cedula de extrangería',
    Pasaporte: 'Pasaporte',
    Salario: 'Salario',
    'Empleado Agregado': 'Empleado Agregado',
    'Editar Empleado': 'Editar Empleado',
    'Empleado Actualizado': 'Empleado Actualizado',
    Consecutivo: 'Consecutivo',
    'Tarjeta de crédito': 'Tarjeta de crédito',
    'Tipo de Egreso': 'Tipo de Egreso',
    'Documento ID': 'Documento ID',
    'Centro de Costos': 'Centro de Costos',
    Concepto: 'Concepto',
    Creador: 'Creador',
    Impuesto: 'Impuesto',
    Retracción: 'Retracción',
    'Añadir Gasto': 'Añadir Gasto',
    'Es punto de venta?': 'Es punto de venta?',
    'Gasto Agregado': 'Gasto Agregado',
    Factura: 'Factura',
    'Editar Gasto': 'Editar Gasto',
    'Gasto Actualizado': 'Gasto Actualizado',
    'Tipo de Ingreso': 'Tipo de Ingreso',
    Cuenta: 'Cuenta',
    Soporte: 'Soporte',
    'Ingreso Agregado': 'Ingreso Agregado',
    'Ingreso Actualizado': 'Ingreso Actualizado',
    'Añadir Cargo': 'Añadir Cargo',
    'Tipo Cargo': 'Tipo Cargo',
    'Cargo Agregado': 'Cargo Agregado',
    'Productos Internos?': 'Productos Internos?',
    'Añadir Producto Tercero': 'Añadir Producto Tercero',
    'Cuenta Contable Ingreso': 'Cuenta Contable Ingreso',
    'Cuenta Contable Egreso': 'Cuenta Contable Egreso',
    'Producto Interno?': 'Producto Interno?',
    'Tipo Interno': 'Tipo Interno',
    'Plan cuentas Apuestas Tickets Tiendas': 'Plan cuentas Apuestas Tickets Tiendas',
    'Plan cuentas Premios Tickets Tiendas': 'Plan cuentas Premios Tickets Tiendas',
    'Plan cuentas Pagos notas de retiro': 'Plan cuentas Pagos notas de retiro',
    'Plan de cuentas Recargas': 'Plan de cuentas Recargas',
    'Editar Producto Tercero': 'Editar Producto Tercero',
    'Producto Tercero Agregado': 'Producto Tercero Agregado',
    'Producto Tercero Actualizado': 'Producto Tercero Actualizado',
    'Producto Terceros': 'Producto Terceros',
    Añadir: 'Añadir',
    'Cuenta Contable': 'Cuenta Contable',
    Agregada: 'Agregada',
    'RUC - NIT': 'RUC - NIT',
    'Añadir Proveedor': 'Añadir Proveedor',
    'Proveedor Agregado': 'Proveedor Agregado',
    'Proveedor Actualizado': 'Proveedor Actualizado',
    'Valor Entradas': 'Valor Entradas',
    'Valor Salidas': 'Valor Salidas',
    Nivel: 'Nivel',
    'Con Cajero': 'Con Cajero',
    Centro: 'Centro',
    'Añadir Tipo': 'Añadir Tipo',
    'Editar Tipo': 'Editar Tipo',
    'Tipo Actualizado': 'Tipo Actualizado',
    'Tipo Agregado': 'Tipo Agregado',
    'Plan de Cuentas': 'Plan de Cuentas',
    Areas: 'Areas',
    Empleados: 'Empleados',
    'Reporte de cierre de día': 'Reporte de cierre de día',
    Conceptos: 'Conceptos',
    Egresos: 'Egresos',
    'Reporte de Gastos': 'Reporte de Gastos',
    Ingresos: 'Ingresos',
    'Otros Ingresos': 'Otros Ingresos',
    Cargos: 'Cargos',
    'Producto Tercero': 'Producto Tercero',
    'Producto Tercero Punto de Venta': 'Producto Tercero Punto de Venta',
    'Productos Terceros': 'Productos Terceros',
    'Productos Terceros Punto de Venta': 'Productos Terceros Punto de Venta',
    'Reporte de Cuadre de día': 'Reporte de Cuadre de día',
    'Reporte de Cuadre de día 2': 'Reporte de Cuadre de día 2',
    Tipos: 'Tipos',
    'Añadir Tipos': 'Añadir Tipos',
    Afiliador: 'Afiliador',
    'No Procesado': 'No Procesado',
    'Añadir Agente': 'Añadir Agente',
    'Estado Validación': 'Estado Validación',
    Región: 'Región',
    Dapartamento: 'Dapartamento',
    Cuidad: 'Cuidad',
    Modificado: 'Modificado',
    '¿ Qué desea realizar ?': '¿ Qué desea realizar ?',
    'Traslado a Saldo Recargas': 'Traslado a Saldo Recargas',
    'Traslado a Saldo Juego': 'Traslado a Saldo Juego',
    'Transferir a saldo Recargas a ': 'Transferir a saldo Recargas a ',
    Transferir: 'Transferir',
    'No Se ha realizado la transferencia. Comunicarse con soporte. ':
        'No Se ha realizado la transferencia. Comunicarse con soporte. ',
    'Se ha realizado la transferencia satisfactoriamente. ': 'Se ha realizado la transferencia satisfactoriamente. ',
    'Transferir a Saldo Juego a ': 'Transferir a Saldo Juego a ',
    'Saldo Juego Actual': 'Saldo Juego Actual',
    'Saldo Recargas Actual': 'Saldo Recargas Actual',
    'Saldo de Recargas': 'Saldo de Recargas',
    'Saldo de Juego': 'Saldo de Juego',
    'Confirmar Valor': 'Confirmar Valor',
    Recargar: 'Recargar',
    'Los montos no coinciden': 'Los montos no coinciden',
    'Cupos Asignados': 'Cupos Asignados',
    'Historial cambios de cupo ': 'Historial cambios de cupo ',
    'Tipo Cupo': 'Tipo Cupo',
    Recargas: 'Recargas',
    'Tipo Transacción': 'Tipo Transacción',
    Salida: 'Salida',
    'Asignado Por': 'Asignado Por',
    '¿ Qué desea realizar ?': '¿ Qué desea realizar ?',
    'Traslado a Saldo Recargas': 'Traslado a Saldo Recargas',
    'Traslado a Saldo Juego': 'Traslado a Saldo Juego',
    'Comisión Nivel 1': 'Comisión Nivel 1',
    'Comisión Nivel 2': 'Comisión Nivel 2',
    'Comisión Nivel 3': 'Comisión Nivel 3',
    'Comisión Nivel 4': 'Comisión Nivel 4',
    'Comisión Punto': 'Comisión Punto',
    'Editar Comisión': 'Editar Comisión',
    'Valores Editados': 'Valores Editados',
    Mensual: 'Mensual',
    Diario: 'Diario',
    'Valor Base': 'Valor Base',
    Comision: 'Comision',
    'Valor Pagado': 'Valor Pagado',
    'External ID': 'External ID',
    Pregunta: 'Pregunta',
    'Saldo Afiliados': 'Saldo Afiliados',
    'Desea pagar comisión en efectivo?': 'Desea pagar comisión en efectivo?',
    'Comisión Pagada': 'Comisión Pagada',
    'Desea abonar comisión a saldo recargas?': 'Desea abonar comisión a saldo recargas?',
    'Desea abonar comisión a saldo juego?': 'Desea abonar comisión a saldo juego?',
    'Desea abonar comisión a saldo afiliados?': 'Desea abonar comisión a saldo afiliados?',
    'Desea Aprobar Comisión': 'Desea Aprobar Comisión',
    'Aprobar Comisión': 'Aprobar Comisión',
    'Comisión Aprobado': 'Comision Aprobado',
    'Restricción IP': 'Restricción IP',
    'Token Google': 'Token Google',
    'Token Local': 'Token Local',
    'No tienes un QR Configurado.': 'No tienes un QR Configurado.',
    UserModifId: 'UserModifId',
    Comisiones: 'Comisiones',
    'Apuestas Totales Liquidadas': 'Apuestas Totales Liquidadas',
    'Deporte Profitness': 'Deporte Profitness',
    'Casino Profitness': 'Casino Profitness',
    'Reporte de Retiros': 'Reporte de Retiros',
    'Tipo de Apuesta': 'Tipo de Apuesta',
    'Apuestas Creadas': 'Apuestas Creadas',
    'Apuestas Cerradas': 'Apuestas Cerradas',
    'Cantidad Tickets': 'Cantidad Tickets',
    Stake: 'Stake',
    'Stake Promedio': 'Stake Promedio',
    Payout: 'Payout',
    Bonos: 'Bonos',
    'Fecha Creación': 'Fecha Creación',
    Pendientes: 'Pendientes',
    Acción: 'Acción',
    'Bono Deposito': 'Bono Deposito',
    'Bono No Deposito': 'Bono No Deposito',
    Freebet: 'Freebet',
    Presupuesto: 'Presupuesto',
    Aprobado: 'Aprobado',
    'Responder Solicitud': 'Responder Solicitud',
    Respuesta: 'Respuesta',
    'Respuesta Generada': 'Respuesta Generada',
    'Envie una Respuesta': 'Envie una Respuesta',
    'Aprobar Solicitud': 'Aprobar Solicitud',
    'Rechazar Solicitud': 'Rechazar Solicitud',
    Requisitos: 'Requisitos',
    'Historial de requisitos enviados': 'Historial de requisitos enviados',
    Requisito: 'Requisito',
    'Añadir Requisito': 'Añadir Requisito',
    'Tipo Usuario': 'Tipo Usuario',
    'Editar Requisito': 'Editar Requisito',
    'Nombre:': 'Nombre:',
    'Tipo Usuario:': 'Tipo Usuario:',
    'Requisito Editado': 'Requisito Editado',
    'Requisito Agregado': 'Requisito Agregado',
    'Estadisticas Marketing': 'Estadisticas Marketing',
    'Marketing Vs Registros': 'Marketing Vs Registros',
    'Top Usuarios': 'Top Usuarios',
    Clave: 'Clave',
    'Datos Configuración': 'Datos Configuración',
    'Reporte de Bonos': 'Reporte de Bonos',
    'Reporte de Casino': 'Reporte de Casino',
    'Reporte de Comisiones': 'Reporte de Comisiones',
    'Reporte de Comisiones Detallado': 'Reporte de Comisiones Detallado',
    'QR Google': 'QR Google',
    'Reporte de Depósitos': 'Reporte de Depósitos',
    'Flujo de Caja': 'Flujo de Caja',
    'Reporte de Flujo de Caja': 'Reporte de Flujo de Caja',
    'Flujo de caja hijos': 'Flujo de caja hijos',
    'Reporte de Flujo de Caja Hijos': 'Reporte de Flujo de Caja Hijos',
    'Reporte de Apuestas': 'Reporte de Apuestas',
    'Flujo Caja Hijos': 'Flujo Caja Hijos',
    'Usuarios Afiliados': 'Usuarios Afiliados',
    Marketing: 'Marketing',
    Informe: 'Informe',
    'Códigos Promocionales': 'Códigos Promocionales',
    'Solicitudes de Agentes': 'Solicitudes de Agentes',
    Requisitos: 'Requisitos',
    'Ultimos 3 días': 'Ultimos 3 días',
    'Ultimos 7 días': 'Ultimos 7 días',
    'Ultimos 30 días': 'Ultimos 30 días',
    'Añadir Punto': 'Añadir Punto',
    Login: 'Login',
    'Apuesta Total': 'Apuesta Total',
    Latitud: 'Latitud',
    Longitud: 'Longitud',
    'Punto de venta Agregado': 'Punto de venta Agregado',
    'Editar Punto': 'Editar Punto',
    Competencia: 'Competencia',
    'Punto de venta Actualizado': 'Punto de venta Actualizado',
    'Publicidad Punto': 'Publicidad Punto',
    'Añadir Publicidad': 'Añadir Publicidad',
    'Añadir Publicidad Cajero': 'Añadir Publicidad Cajero',
    Cajeros: 'Cajeros',
    'Añadir Cajero': 'Añadir Cajero',
    Ruta: 'Ruta',
    'Publicidad Añadida': 'Publicidad Añadida',
    'Editar Publicidad': 'Editar Publicidad',
    'Publicidad Actualizada': 'Publicidad Actualizada',
    'Publicidad Cajero Añadida': 'Publicidad Cajero Añadida',
    'Editar Publicidad Cajero': 'Editar Publicidad Cajero',
    'Abrir Publicidad': 'Abrir Publicidad',
    'Computador ID': 'Computador ID',
    'Min Apuesta': 'Min Apuesta',
    'Max Apuesta Live': 'Max Apuesta Live',
    'Max Apuesta PreMatch': 'Max Apuesta PreMatch',
    'Cajero Agregado': 'Cajero Agregado',
    'Comisión Usuario': 'Comisión Usuario',
    'por Abuelo': 'por Abuelo',
    'por Padre': 'por Padre',
    'por Hijo': 'por Hijo',
    'por Nieto': 'por Nieto',
    Total: 'Total',
    'Total:': 'Total:',
    'Usuario REF': 'Usuario REF',
    'Fecha de Creación': 'Fecha de Creación',
    'Pregunta ': 'Pregunta ',
    'Seleccione el tipo de saldo ': 'Seleccione el tipo de saldo ',
    'Saldo Recarga': 'Saldo Recarga',
    'Ganancias sujetas a impuestos': 'Ganancias sujetas a impuestos',
    'Valor Apostado': 'Valor Apostado',
    'Valor Premio': 'Valor Premio',
    Ganancia: 'Ganancia',
    'La contraseña debe contener mínimo 6 caracteres y un número, un carácter no se puede repetir más de 3 veces consecutivamente ':
        'La contraseña debe contener mínimo 6 caracteres y un número, un carácter no se puede repetir más de 3 veces consecutivamente ',
    'Fecha ultima detección': 'Fecha ultima detección',
    Plataforma: 'Plataforma',
    'Nombre Archivo': 'Nombre Archivo',
    'Hash Original': 'Hash Original',
    'Hash Detectado': 'Hash Detectado',
    'Fecha modificación': 'Fecha modificación',
    'Fecha ultima detección': 'Fecha ultima detección',
    'Reporte de Hash': 'Reporte de Hash',
    Departamento: 'Departamento',
    Tecnología: 'Tecnología',
    Financiero: 'Financiero',
    'Filtrar Tabla': 'Filtrar Tabla',
    'Dirigido al Departamento': 'Dirigido al Departamento',
    'Título de la petición': 'Título de la petición',
    Título: 'Título',
    'Generar Petición': 'Generar Petición',
    Generar: 'Generar',
    'Añadir Respuesta': 'Añadir Respuesta',
    'Respuestas de la petición': 'Respuestas de la petición',
    'La petición debe estar activa': 'La petición debe estar activa',
    Acción: 'Acción',
    'Usuario Creo': 'Usuario Creo',
    'Desea cerrar la petición?': 'Desea cerrar la petición?',
    'Cerrar Peticíon': 'Cerrar Peticíon',
    'Estado de petición actualizada': 'Estado de petición actualizada',
    'Desea Activar la petición?': 'Desea Activar la petición?',
    'Activar Peticíon': 'Activar Peticíon',
    'Responder Petición': 'Responder Petición',
    Peticiones: 'Peticiones',
    'Mensaje Id': 'Mensaje Id',
    Casino: 'Casino',
    'Live Casino': 'Live Casino',
    Abreviado: 'Abreviado',
    'Añadir Mensaje': 'Añadir Mensaje',
    'Editar Mensaje': 'Editar Mensaje',
    Mensaje: 'Mensaje',
    Asunto: 'Asunto',
    Emisor: 'Emisor',
    Receptor: 'Receptor',
    Leido: 'Leido',
    Mensajes: 'Mensajes',
    'Tipo de Producto': 'Tipo de Producto',
    'Fecha Inicio': 'Fecha Inicio',
    'Fecha Fin': 'Fecha Fin',
    'Añadir Liga': 'Añadir Liga',
    Resultados: 'Resultados',
    'Fecha del ultimo logueo': 'Fecha del ultimo logueo',
    'Reporte de Apuestas Deportivas': 'Reporte de Apuestas Deportivas',
    Usuarios: 'Usuarios',
    'Tabla de Resultados': 'Tabla de Resultados',
    Nro: 'Nro',
    Puntuación: 'Puntuación',
    'Saldo Actual de usuarios por Edades': 'Saldo Actual de usuarios por Edades',
    Deportivo: 'Deportivo',
    Si: 'Si',
    'Liga Agregada Correctamente': 'Liga Agregada Correctamente',
    'La Fecha de inicio debe ser menor a la fecha fin.': 'La Fecha de inicio debe ser menor a la fecha fin.',
    'Añadir Liga:': 'Añadir Liga:',
    'Segundo Nombre': 'Segundo Nombre',
    Notificaciones: 'Notificaciones',
    'Lista de Ligas': 'Lista de Ligas',
    Información: 'Información',
    Reportes: 'Reportes',
    Configuración: 'Configuración',
    'Reporte de Usuarios': 'Reporte de Usuarios',
    'Publicidad Máquina': 'Publicidad Máquina',
    'Id Nota de Retiro': 'Id Nota de Retiro',
    'Valor a pagar': 'Valor a pagar',
    'Premio Proyectado': 'Premio Proyectado',
    Ganador: 'Ganador',
    'Pagar Nota Retiro': 'Pagar Nota Retiro',
    'No. Ticket': 'No. Ticket',
    'Clave Ticket': 'Clave Ticket',
    'Pagar Premio': 'Pagar Premio',
    Encendida: 'Encendida',
    Apagada: 'Apagada',
    'Usuario Actualizó': 'Usuario Actualizó',
    'Reporte de Logs': 'Reporte de Logs',
    'Reporte de Actualizaciones': 'Reporte de Actualizaciones',
    'Actualizar Versión ': 'Actualizar Versión ',
    Vinculo: 'Vinculo',
    Actualizar: 'Actualizar',
    'Actualizar Ambos ': 'Actualizar Ambos ',
    'Enviar Comando a ': 'Enviar Comando a ',
    Enviar: 'Enviar',
    'Tipo Establecimiento': 'Tipo Establecimiento',
    Versión: 'Versión',
    'Documento 1': 'Documento 1',
    'Documento 2': 'Documento 2',
    'Añadir Traducción': 'Añadir Traducción',
    'Traducción Agregada': 'Traducción Agregada',
    'Editar Traducción': 'Editar Traducción',
    'Añadir Traducción': 'Añadir Traducción',
    'Traducción Editada': 'Traducción Editada',
    'Obtener URL': 'Obtener URL',
    'Subir Imagen': 'Subir Imagen',
    'Primer nombre': 'Primer nombre',
    'CashDesk Name': 'CashDesk Name',
    Hora: 'Hora',
    'Usuario que lo creo': 'Usuario que lo creo',
    'Tipo:': 'Tipo:',
    'Descripción:': 'Descripción:',
    'Valor:': 'Valor:',
    'Ingreso por tarjeta de crédito añadido satisfactoriamente':
        'Ingreso por tarjeta de crédito añadido satisfactoriamente',
    'Seleccione tipo de factura': 'Seleccione tipo de factura',
    POS: 'POS',
    CARTA: 'CARTA',
    'Nro. Documento': 'Nro. Documento',
    'Proveedor Tercero': 'Proveedor Tercero',
    'Concepto:': 'Concepto:',
    'Nro. Documento:': 'Nro. Documento:',
    'Proveedores Terceros': 'Proveedores Terceros',
    'Error, comuniquese con soporte. ': 'Error, comuniquese con soporte. ',
    'Egreso añadido satisfactoriamente': 'Egreso añadido satisfactoriamente',
    'Proveedor Tercero:': 'Proveedor Tercero:',
    'Ingreso añadido satisfactoriamente': 'Ingreso añadido satisfactoriamente',
    'Dinero Inicial:': 'Dinero Inicial:',
    'Total Ingresos:': 'Total Ingresos:',
    'Total Egresos:': 'Total Egresos:',
    'Ingresos Tarjeta Credito:': 'Ingresos Tarjeta Credito:',
    'Total:': 'Total:',
    'Verifique que todos los datos sean validos ': 'Verifique que todos los datos sean validos ',
    'Forma Pago 1': 'Forma Pago 1',
    'Pago Bono / T.C.': 'Pago Bono / T.C.',
    'Valor Entradas Efectivo': 'Valor Entradas Efectivo',
    'Valor Entradas Bono / T.C.': 'Valor Entradas Bono / T.C.',
    'Valor Entradas Traslados': 'Valor Entradas Traslados',
    'Valor Entradas Recargas': 'Valor Entradas Recargas',
    'Valor Salidas Efectivo': 'Valor Salidas Efectivo',
    'Valor Salidas Traslados': 'Valor Salidas Traslados',
    'Valor Salidas Notas de Retiro': 'Valor Salidas Notas de Retiro',
    Saldo: 'Saldo',
    'Pagada?': 'Pagada?',
    'Numero del cliente:': 'Numero del cliente:',
    'Cedula del cliente:': 'Cedula del cliente:',
    'Email del cliente:': 'Email del cliente:',
    'Campo No Valido': 'Campo No Valido',
    'Filtre Mínimo por un campo': 'Filtre Mínimo por un campo',
    'Nro. de Cliente:': 'Nro. de Cliente:',
    'Nombre del Cliente:': 'Nombre del Cliente:',
    'País:': 'País:',
    'Moneda:': 'Moneda:',
    'Valor a Recargar:': 'Valor a Recargar:',
    'Desea Realizar la Recarga?': 'Desea Realizar la Recarga?',
    'Ocurrio un error...': 'Ocurrio un error...',
    'Recarga Completada Satisfactoriamente': 'Recarga Completada Satisfactoriamente',
    'Añadir Competidor': 'Añadir Competidor',
    Competidores: 'Competidores',
    'Competidor Agregado': 'Competidor Agregado',
    'Editar Competidor': 'Editar Competidor',
    'Competidor Editado': 'Competidor Editado',
    'Fecha de creación:': 'Fecha de creación:',
    'Nombre de Usuario:': 'Nombre de Usuario:',
    'Valor de la nota:': 'Valor de la nota:',
    'Eliminar Nota': 'Eliminar Nota',
    'ID Nota de Retiro:': 'ID Nota de Retiro:',
    'Observaciones:': 'Observaciones:',
    'Nro Nota Retiro:': 'Nro Nota Retiro:',
    'Nro Usuario:': 'Nro Usuario:',
    'Fecha Eliminación': 'Fecha Eliminación',
    'Nombre del Usuario:': 'Nombre del Usuario:',
    'Usuario que la Eliminó:': 'Usuario que la Eliminó:',
    'Fecha Nota': 'Fecha Nota',
    'Nro Nota Retiro': 'Nro Nota Retiro',
    'Valor Nota': 'Valor Nota',
    Observaciones: 'Observaciones',
    'Historial de gestiones': 'Historial de gestiones',
    'Fecha/hora': 'Fecha/hora',
    Texto: 'Texto',
    'Nota Generada': 'Nota Generada',
    'Nombres:': 'Nombres:',
    'Apellidos:': 'Apellidos:',
    'Teléfono:': 'Teléfono:',
    'Skype:': 'Skype:',
    'Dirección:': 'Dirección:',
    'Email:': 'Email:',
    'Empresa:': 'Empresa:',
    Empresa: 'Empresa',
    Provincia: 'Provincia',
    Observacion: 'Observacion',
    'Fecha/Hora Ultima Modif': 'Fecha/Hora Ultima Modif',
    'Usuario Ultima Modif': 'Usuario Ultima Modif',
    'Desea Terminar Gestión?': 'Desea Terminar Gestión?',
    'Terminar Gestión': 'Terminar Gestión',
    'Gestión Terminada satisfactoriamente. ': 'Gestión Terminada satisfactoriamente. ',
    'Cedula de Ciudadania': 'Cedula de Ciudadania',
    'Cedula de Extranjeria': 'Cedula de Extranjeria',
    'Primer Nombre:': 'Primer Nombre:',
    'Nro Documento:': 'Nro Documento:',
    'Segundo Nombre:': 'Segundo Nombre:',
    'Segundo Nombre': 'Segundo Nombre',
    'Primer Apellido:': 'Primer Apellido:',
    'Primer Apellido': 'Primer Apellido',
    'Segundo Apellido:': 'Segundo Apellido:',
    'Segundo Apellido': 'Segundo Apellido',
    'Nro Cheque:': 'Nro Cheque:',
    'Nro Cheque': 'Nro Cheque',
    Origen: 'Origen',
    'Nota Retiro': 'Nota Retiro',
    Ticket: 'Ticket',
    'Cliente:': 'Cliente:',
    Cliente: 'Cliente',
    'Documento Referente:': 'Documento Referente:',
    'Documento Referente': 'Documento Referente',
    'Doc. Cliente:': 'Doc. Cliente:',
    'Doc. Cliente': 'Doc. Cliente',
    'Nro. Recarga:': 'Nro. Recarga:',
    'Nro. Recarga': 'Nro. Recarga',
    'Nro. Cliente:': 'Nro. Cliente:',
    'Nro. Cliente': 'Nro. Cliente',
    'Nombre Cliente:': 'Nombre Cliente:',
    'Nombre Cliente': 'Nombre Cliente',
    'Usuario Solicita': 'Usuario Solicita',
    Campo: 'Campo',
    Antiguo: 'Antiguo',
    Nuevo: 'Nuevo',
    Aprobadas: 'Aprobadas',
    Rechazadas: 'Rechazadas',
    'Desea Rechazar el log?': 'Desea Rechazar el log?',
    'Rechazar log': 'Rechazar log',
    'Estado de log actualizado': 'Estado de log actualizado',
    'Desea Aprobar el log?': 'Desea Aprobar el log?',
    UserName: 'UserName',
    Listo: 'Listo',
    Aprobada: 'Aprobada',
    'Tipo de usuario': 'Tipo de usuario',
    'Administrador General': 'Administrador General',
    'Administrador Secundario': 'Administrador Secundario',
    Operador: 'Operador',
    'System Administrator': 'System Administrator',
    Consultas: 'Consultas',
    'ADMIN AFILIADOS': 'ADMIN AFILIADOS',
    CUSTOM: 'CUSTOM',
    'Usuario de País': 'Usuario de País',
    'Categoría cliente': 'Categoría cliente',
    'Añadir Usuario': 'Añadir Usuario',
    'Numero de Documento': 'Numero de Documento',
    Género: 'Género',
    Cumpleaños: 'Cumpleaños',
    'Está bloqueado?': 'Está bloqueado?',
    'País Residencia': 'País Residencia',
    'Provincia/Región Residencia': 'Provincia/Región Residencia',
    'Ciudad Residencia': 'Ciudad Residencia',
    'Código Zip': 'Código Zip',
    Celular: 'Celular',
    'Fecha de registro': 'Fecha de registro',
    Perfil: 'Perfil',
    Página: 'Página',
    DíasCaducidadClave: 'DíasCaducidadClave',
    'Menus no permitidos': 'Menus no permitidos',
    'Menus Permitidos': 'Menus Permitidos',
    ADMIN: 'ADMIN',
    ADMIN2: 'ADMIN2',
    'ADMIN AGGREGATOR': 'ADMIN AGGREGATOR',
    CAJERO: 'CAJERO',
    CONCESIONARIO: 'CONCESIONARIO',
    CONCESIONARIO2: 'CONCESIONARIO2',
    OPERADOR: 'OPERADOR',
    PUNTOVENTA: 'PUNTOVENTA',
    CONSULTAS: 'CONSULTAS',
    ADMINAFILIADOS: 'ADMINAFILIADOS',
    CUSTOM: 'CUSTOM',
    'Debe de seleccionar un usuario.': 'Debe de seleccionar un usuario.',
    Menu: 'Menu',
    Submenu: 'Submenu',
    Adicionar: 'Adicionar',
    Editar: 'Editar',
    'Cedula Nacional': 'Cedula Nacional',
    'Cedula Extranjera': 'Cedula Extranjera',
    Pasaporte: 'Pasaporte',
    Trabajador: 'Trabajador',
    'Familiar Trabajador': 'Familiar Trabajador',
    'Añadir Usuario a Bloquear': 'Añadir Usuario a Bloquear',
    'Usuario Asociado': 'Usuario Asociado',
    Regional: 'Regional',
    'Tipo Punto': 'Tipo Punto',
};

// FILE DOCUMENTED
